var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3874,
    height: 1783,
    viewBox: "0 0 3874 1783",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1443.24 508.664C1552.44 457.854 1680.2 428.647 1816.74 428.647C2095.36 428.647 2337.42 550.257 2459.76 728.878C2460.74 730.303 2462.8 730.401 2463.94 729.096C2503 684.091 2559.69 659.823 2617.65 669.544C2657.63 676.249 2691.76 698.042 2716.39 729.062C2717.19 730.074 2718.61 730.364 2719.73 729.73C2839.56 662.344 2986.86 622.621 3146.1 622.621C3414.5 622.621 3648.97 735.473 3775.18 903.43L3874 913.582V1783H0V530.397L0.555224 530.454C13.6586 235.283 401.13 0 699.56 0C974.312 0 1202.48 199.43 1247.18 461.417C1247.49 463.218 1249.51 464.174 1251.11 463.281C1279.87 447.174 1312.31 440.414 1345.07 445.909C1384.05 452.445 1416.94 475.232 1439.99 507.788C1440.72 508.825 1442.09 509.2 1443.24 508.664Z",
    fill: "#151C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBanner);
export default __webpack_public_path__ + "static/media/cloud-banner.7327c0a29dbc0495dbcca2c0d57f7771.svg";
export { ForwardRef as ReactComponent };